import React from 'react';
export function SocialProofBar() {
  return <section className="w-full bg-[#001a2d] py-12 px-4" data-id="element-299">
      <div className="max-w-5xl mx-auto" data-id="element-300">
        {/* Stats */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mb-12 text-center" data-id="element-301">
          <div data-id="element-302">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-303">
              +500
            </div>
            <div className="text-[#00B4D8] text-sm font-semibold mt-1" data-id="element-304">
              docentes confían
            </div>
          </div>
          <div data-id="element-305">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-306">6</div>
            <div className="text-[#00B4D8] text-sm font-semibold mt-1" data-id="element-307">
              Tomos listos
            </div>
          </div>
          <div data-id="element-308">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-309">6</div>
            <div className="text-[#00B4D8] text-sm font-semibold mt-1" data-id="element-310">
              Bonos incluidos
            </div>
          </div>
          <div data-id="element-311">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-312">
              4.9/5
            </div>
            <div className="text-[#00B4D8] text-sm font-semibold mt-1" data-id="element-313">
              calificación ⭐
            </div>
          </div>
        </div>

        {/* Micro testimonials */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-314">
          <div className="flex items-start gap-3 bg-black/40 border border-[#00B4D8]/20 rounded-xl p-4" data-id="element-315">
            <div className="w-10 h-10 rounded-full bg-[#00B4D8]/20 flex items-center justify-center text-[#00B4D8] font-black text-sm flex-shrink-0" data-id="element-316">
              MG
            </div>
            <div data-id="element-317">
              <div className="text-[#00B4D8] text-xs mb-1" data-id="element-318">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-319">
                "Organicé todo el año en una tarde. Nunca más llegué sin
                material al aula."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-320">
                — Mariela G., Córdoba | Docente de Francés
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#00B4D8]/20 rounded-xl p-4" data-id="element-321">
            <div className="w-10 h-10 rounded-full bg-[#00B4D8]/20 flex items-center justify-center text-[#00B4D8] font-black text-sm flex-shrink-0" data-id="element-322">
              LP
            </div>
            <div data-id="element-323">
              <div className="text-[#00B4D8] text-xs mb-1" data-id="element-324">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-325">
                "El subjonctif por fin se entiende. Mis alumnos lo usan sin
                miedo."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-326">
                — Laura P., Rosario | Instituto de Idiomas
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#00B4D8]/20 rounded-xl p-4" data-id="element-327">
            <div className="w-10 h-10 rounded-full bg-[#00B4D8]/20 flex items-center justify-center text-[#00B4D8] font-black text-sm flex-shrink-0" data-id="element-328">
              RM
            </div>
            <div data-id="element-329">
              <div className="text-[#00B4D8] text-xs mb-1" data-id="element-330">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-331">
                "Vale cada peso. Nunca más llegué sin material."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-332">
                — Roberto M., Buenos Aires | Docente de Francés
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}